<section id="home" class="slider_area">
    <div class="carousel-inner">
        <div class="carousel-item active">
            <div class="slider-content">&nbsp;</div>
        </div>
    </div>
</section>

<section class="white-area">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="section-title text-center pb-10">
                    <h3 class="title">{{ 'FOOTER.SITEMAP_TITLE' | translate }}</h3>
                    <p class="text">{{ 'FOOTER.SITEMAP_TEXT' | translate }}</p>
                </div>
                <div class="sitemap-content">
                    <div class="sitemap-section">
                        <h4>{{ 'FOOTER.SITEMAP_MAIN_PAGES' | translate }}</h4>
                        <ul>
                            <li><a routerLink="/main">{{ 'FOOTER.SITEMAP_HOME' | translate }}</a></li>
                            <li><a routerLink="/about-us">{{ 'FOOTER.SITEMAP_ABOUT' | translate }}</a></li>
                            <li><a routerLink="/management-tool">{{ 'FOOTER.SITEMAP_SERVICES' | translate }}</a></li>
                            <li><a routerLink="/blog">{{ 'FOOTER.SITEMAP_BLOG' | translate }}</a></li>
                            <li><a routerLink="/contact">{{ 'FOOTER.SITEMAP_CONTACT' | translate }}</a></li>
                        </ul>
                    </div>
                    <div class="sitemap-section">
                        <h4>{{ 'FOOTER.SITEMAP_SERVICES' | translate }}</h4>
                        <ul>
                            <li><a routerLink="/management-tool">{{ 'FOOTER.SITEMAP_PROPERTY_MANAGEMENT' | translate
                                    }}</a></li>
                            <li><a routerLink="/todo">{{ 'FOOTER.SITEMAP_TASK_MANAGEMENT' | translate }}</a></li>
                            <li><a routerLink="/documents">{{ 'FOOTER.SITEMAP_DOCUMENT_MANAGEMENT' | translate }}</a>
                            </li>
                            <li><a routerLink="/calculators">{{ 'FOOTER.SITEMAP_CALCULATORS' | translate }}</a></li>
                        </ul>
                    </div>
                    <div class="sitemap-section">
                        <h4>{{ 'FOOTER.SITEMAP_LEGAL' | translate }}</h4>
                        <ul>
                            <li><a routerLink="/legal/terms">{{ 'FOOTER.SITEMAP_TERMS' | translate }}</a></li>
                            <li><a routerLink="/legal/privacy-policy">{{ 'FOOTER.SITEMAP_PRIVACY' | translate }}</a>
                            </li>
                            <li><a routerLink="/legal/cookie-preferences">{{ 'FOOTER.SITEMAP_COOKIES' | translate }}</a>
                            </li>
                            <li><a routerLink="/legal/gdpr">{{ 'FOOTER.SITEMAP_LEGAL_NOTES' | translate }}</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>